import ApiService from '@/services/core/api.service'

const AdminSalePeopleService = {
  async get (query) {
    return ApiService.get(`admin/sales-people?${query}`)
  }
}

export default AdminSalePeopleService
